import {setDefaultEvent} from '../mprExecutiveSummary';
import {showErrorNotification} from "../../global/notifications";

export default function () {
    const $recoveryAmounts = $('[id*="__ExpectedRecoveryAmount"]');
    createProjectionHeader($('#newRevenueProjection'));
    attachSaveButtonEvent($('#saveButton'));
    attachPercentUpdateEvent($('[id*="__ExpectedRecoveryPercent"]'));
    attachAmountUpdateEvent($recoveryAmounts);
    setDefaultEvent();

    setCurrentContract();

    attachChangeRevenueProjectionEvent();
    calculateTotalPcoBookedValue();

    createAccountingMonthSelection();

    $('.topics.hide-v, #aside .hide-v').removeClass('hide-v');
    $('.page-message').remove();
}

const createProjectionHeader = $createHeaderBtn => {
    if ($createHeaderBtn.length) {
        $createHeaderBtn.click(function () {
            $('#RevenueProjection_Id').val(-2);
            $('#RevenueProjectionModelForm').submit();
        });
    }
};

const attachSaveButtonEvent = $saveButton => {
    if ($saveButton.length) {
        $saveButton.click(function () {
            if (checkAccountingMonthValidation() && checkCommentValidation()) {
                $('#RevenueProjection_Finalized').val($('#finalizeForm').prop('checked'));
                $('#RevenueProjectionModelForm').submit();
            }
        });
    }
};

const checkAccountingMonthValidation = () => {
    if($('select.js-accounting-month').data('kendoDropDownList').value() !== '') return true;

    showErrorNotification('Please select an accounting month');
    return false; 
}

const checkCommentValidation = () => {
    const $expectedRecoveryPercent = $('[id*=_ExpectedRecoveryPercent]');
    let success = true;
    $('.fieldValidationError').removeClass('fieldValidationError')

    $.each($expectedRecoveryPercent, function (index, ele) {
        const $parent = $(ele).parents('.js-pco-type');
        const pcoType = $parent.data('pcotype');
        if (ele.value < 100 || pcoType === 'PCO-B') {
            const $comment = $parent.find('[id*=_Comments]');
            
            if($comment.val() === ''){
                success = false;
                $comment.addClass('fieldValidationError');
            }
        }
    });

    if (!success) {
        showErrorNotification('A comment is required for All PCO-Bs and any PCO-As with an expected recovery less than 100%');
    }
    return success;
}

const attachPercentUpdateEvent = $percentInputs => {
    if ($percentInputs.length) {
        $percentInputs.blur(function () {
            const $row = $(this).parents('li');
            const $amountInput = $row.find('[id*="__ExpectedRecoveryAmount"]');
            const $bookedValue = $row.find('[id*="__RevTotal"]');

            if ($amountInput.length && $bookedValue.length) {
                const bookedValue = Number($bookedValue.val());
                const k_amountInput = $amountInput.data('kendoNumericTextBox');

                if (k_amountInput) {
                    const amount = bookedValue * (this.value / 100);
                    k_amountInput.value(amount);
                    // Trigger change event to recalculate totals
                    $amountInput.change();
                }
            }
        })
            .on('keydown', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    $(this).blur();
                }
            });
    }
};

const attachAmountUpdateEvent = $amountInputs => {
    if ($amountInputs.length) {
        $amountInputs
            .blur(function () {
                const $row = $(this).parents('li');
                const $percentInput = $row.find('[id*="__ExpectedRecoveryPercent"]');
                const $bookedValue = $row.find('[id*="__RevTotal"]');

                if ($percentInput.length && $bookedValue.length) {
                    const bookedValue = Number($bookedValue.val());
                    const k_percentInput = $percentInput.data('kendoNumericTextBox');

                    if (k_percentInput) {
                        let percentage = (this.value / bookedValue) * 100;
                        if (percentage > 100) {
                            percentage = 100;
                            $(this)
                                .data('kendoNumericTextBox')
                                .value(bookedValue);
                        }
                        k_percentInput.value(percentage);
                    }
                }
            })
            .on('change', function () {
                calculateTotalPcoRecovery();
            })
            .on('keydown', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    $(this).blur();
                }
            });
    }
};

const setCurrentContract = () => {
    const $approvedChangeOrders = $('.approvedPco');
    let approvedPcoTotal = 0;

    if ($approvedChangeOrders.length) {
        $.each($approvedChangeOrders, function (index, ele) {
            approvedPcoTotal += Number(ele.value);
        });
    }

    $('.approvedChangeOrders').text(kendo.toString(approvedPcoTotal, '##,#.00'));
    const originalContract = Number($('.originalContract').val());

    $('.currentContract').text(kendo.toString(originalContract + approvedPcoTotal, '##,#.00'));
    $('.currentContractVal').val(originalContract + approvedPcoTotal);

    calculateTotalPcoRecovery();
};

const calculateTotalPcoRecovery = () => {
    const $recoveryAmounts = $('[id*="__ExpectedRecoveryAmount"]');
    if ($recoveryAmounts.length) {
        let recoveryTotal = 0;
        let pcoATotal = 0;
        let pcoBTotal = 0;
        $.each($recoveryAmounts, function (index, ele) {
            const pcoType = $(ele)
                .parents('.js-pco-type')
                .data('pcotype');
            const value = Number(ele.value);
            if (pcoType) {
                if (pcoType === 'PCO-A') {
                    pcoATotal += value;
                } else if (pcoType === 'PCO-B') {
                    pcoBTotal += value;
                }
            }
            recoveryTotal += value;
        });

        const $pcoATotalSpan = $('span.pcoATotal');
        const $pcoBTotalSpan = $('span.pcoBTotal');
        if ($pcoATotalSpan.length) $pcoATotalSpan.text(kendo.toString(pcoATotal, '##,#.00'));
        if ($pcoBTotalSpan.length) $pcoBTotalSpan.text(kendo.toString(pcoBTotal, '##,#.00'));
        $('.totalPcoRecovery').text(kendo.toString(recoveryTotal, '##,#.00'));
        $('.totalPcoRecoveryVal').val(recoveryTotal);
    }

    calculateTotalRevenueProjection();
};

const calculateTotalRevenueProjection = () => {
    $('.totalRevenueProjection').text(kendo.toString(Number($('.totalPcoRecoveryVal').val()) + Number($('.currentContractVal').val()), '##,#.00'));
};

const attachChangeRevenueProjectionEvent = () => {
    const $projectionSelect = $('#projectionId');

    if ($projectionSelect.length) {
        $projectionSelect.change(function () {
            $(this)
                .parents('form')
                .submit();
        });
    }
};

const calculateTotalPcoBookedValue = () => {
    const $bookedValues = $('[id*="__RevTotal"]');
    if ($bookedValues.length) {
        let bookedTotal = 0;
        let pcoABookedTotal = 0;
        let pcoBBookedTotal = 0;
        $.each($bookedValues, function (index, ele) {
            const pcoType = $(ele)
                .parents('.js-pco-type')
                .data('pcotype');
            const value = Number(ele.value);
            if (pcoType) {
                if (pcoType === 'PCO-A') {
                    pcoABookedTotal += value;
                } else if (pcoType === 'PCO-B') {
                    pcoBBookedTotal += value;
                }
            }
            bookedTotal += value;
        });

        const $pcoABookedTotalSpan = $('span.pcoABookedTotal');
        const $pcoBBookedTotalSpan = $('span.pcoBBookedTotal');
        if ($pcoABookedTotalSpan.length) $pcoABookedTotalSpan.text(kendo.toString(pcoABookedTotal, '##,#.00'));
        if ($pcoBBookedTotalSpan.length) $pcoBBookedTotalSpan.text(kendo.toString(pcoBBookedTotal, '##,#.00'));
        // $('.totalPcoRecovery').text(kendo.toString(bookedTotal, '##,#.00'));
        // $('.totalPcoRecoveryVal').val(bookedTotal);
    }

    calculateTotalRevenueProjection();
};

const createAccountingMonthSelection = () => {
    const $accountingMonthSelect = $('select.js-accounting-month');

    if ($accountingMonthSelect.length) {
        const $pid = $('#pid');
        const k_dropDownList = $accountingMonthSelect.kendoDropDownList({
            optionLabel: 'Select Month...',
            dataTextField: 'text', dataValueField: 'value', dataSource: {
                transport: {
                    read: {
                        url: `/Operations/RevenueProjection/GetAccountingMonthOptions?pid=${$pid.val()}`
                    }
                }
            }
        }).data('kendoDropDownList');

        k_dropDownList.value($accountingMonthSelect.data('value'))
    }
}